<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex#contentArea.clusterize-content(style="width: 100%;").mb-5
        thead
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 250px;")
              div {{ $t('ui.event') }}
            th
              div
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 250px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td
              div.form-row
                div.mb-2(v-if="item.f3wth || item.f3wta || item.f3wtd" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="3")
                          div.text-center(:title="$t('ui.full_time')") {{ $t('ui.full_time') }}
                      tr
                        th(v-if="item.f3wth")
                          div.text-center(:title="item.f3wth") {{ item.f3wth }}
                        th(v-if="item.f3wta")
                          div.text-center(:title="item.f3wta") {{ item.f3wta }}
                        th(v-if="item.f3wtd")
                          div.text-center(:title="item.f3wtd") {{ item.f3wtd }}
                    tbody
                      tr
                        td(v-if="item.f3wh")
                          div.text-center(:class="{'up': item.f3wh_blink }") {{ item.f3wh }}
                        td(v-if="item.f3wa")
                          div.text-center(:class="{'up': item.f3wa_blink }") {{ item.f3wa }}
                        td(v-if="item.f3wd")
                          div.text-center(:class="{'up': item.f3wd_blink }") {{ item.f3wd }}
                div.mb-2(v-if="item.h3wth || item.h3wta || item.h3wtd" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="3")
                          div.text-center(:title="$t('ui.half_time')") {{ $t('ui.half_time') }}
                      tr
                        th(v-if="item.h3wth")
                          div.text-center(:title="item.h3wth") {{ item.h3wth }}
                        th(v-if="item.h3wta")
                          div.text-center(:title="item.h3wta") {{ item.h3wta }}
                        th(v-if="item.h3wtd")
                          div.text-center(:title="item.h3wtd") {{ item.h3wtd }}
                    tbody
                      tr
                        td(v-if="item.h3wh")
                          div.text-center(:class="{'up': item.h3wh_blink }") {{ item.h3wh }}
                        td(v-if="item.h3wa")
                          div.text-center(:class="{'up': item.h3wa_blink }") {{ item.h3wa }}
                        td(v-if="item.h3wd")
                          div.text-center(:class="{'up': item.h3wd_blink }") {{ item.h3wd }}
                div.mb-2(v-if="item.both || item.one || item.ng" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="3")
                          div.text-center(:title="$t('ui.both_one_ng')") {{ $t('ui.both_one_ng') }}
                      tr
                        th(v-if="item.both")
                          div.text-center(:title="$t('ui.both')") {{ $t('ui.both') }}
                        th(v-if="item.one")
                          div.text-center(:title="$t('ui.one')") {{ $t('ui.one') }}
                        th(v-if="item.ng")
                          div.text-center(:title="$t('ui.no_goal')") {{ $t('ui.no_goal') }}
                    tbody
                      tr
                        td(v-if="item.both")
                          div.text-center(:class="{'up': item.both_blink }") {{ item.both }}
                        td(v-if="item.one")
                          div.text-center(:class="{'up': item.one_blink }") {{ item.one }}
                        td(v-if="item.ng")
                          div.text-center(:class="{'up': item.ng_blink }") {{ item.ng }}
                div.mb-2(v-if="item.hy || item.hn || item.ay || item.an" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="4")
                          div.text-center(:title="$t('ui.clean_sheet')") {{ $t('ui.clean_sheet') }}
                      tr
                        th(v-if="item.hy")
                          div.text-center(:title="$t('ui.home_yes')") {{ $t('ui.home_yes') }}
                        th(v-if="item.hn")
                          div.text-center(:title="$t('ui.home_no')") {{ $t('ui.home_no') }}
                        th(v-if="item.ay")
                          div.text-center(:title="$t('ui.away_yes')") {{ $t('ui.away_yes') }}
                        th(v-if="item.an")
                          div.text-center(:title="$t('ui.away_no')") {{ $t('ui.away_no') }}
                    tbody
                      tr
                        td(v-if="item.hy")
                          div.text-center(:class="{'up': item.hy_blink }") {{ item.hy }}
                        td(v-if="item.hn")
                          div.text-center(:class="{'up': item.hn_blink }") {{ item.hn }}
                        td(v-if="item.ay")
                          div.text-center(:class="{'up': item.ay_blink }") {{ item.ay }}
                        td(v-if="item.an")
                          div.text-center(:class="{'up': item.an_blink }") {{ item.an }}
                div.mb-2(v-if="item.twtnh || item.twtna" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="2")
                          div.text-center(:title="$t('ui.to_win_to_nil')") {{ $t('ui.to_win_to_nil') }}
                      tr
                        th(v-if="item.twtnh")
                          div.text-center(:title="$t('ui.home')") {{ $t('ui.home') }}
                        th(v-if="item.twtna")
                          div.text-center(:title="$t('ui.away')") {{ $t('ui.away') }}
                    tbody
                      tr
                        td(v-if="item.twtnh")
                          div.text-center(:class="{'up': item.twtnh_blink }") {{ item.twtnh }}
                        td(v-if="item.twtna")
                          div.text-center(:class="{'up': item.twtna_blink }") {{ item.twtna }}
                div.mb-2(v-if="item.dnbh || item.dnba" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="2")
                          div.text-center(:title="$t('ui.draw_no_bet')") {{ $t('ui.draw_no_bet') }}
                      tr
                        th(v-if="item.dnbh")
                          div.text-center(:title="$t('ui.home')") {{ $t('ui.home') }}
                        th(v-if="item.dnba")
                          div.text-center(:title="$t('ui.away')") {{ $t('ui.away') }}
                    tbody
                      tr
                        td(v-if="item.dnbh")
                          div.text-center(:class="{'up': item.dnbh_blink }") {{ item.dnbh }}
                        td(v-if="item.dnba")
                          div.text-center(:class="{'up': item.dnba_blink }") {{ item.dnba }}
                div.mb-2(v-if="item.fh || item.sh || item.tie" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th(colspan="3")
                          div.text-center(:title="$t('ui.highest_scoring_half')") {{ $t('ui.highest_scoring_half') }}
                      tr
                        th(v-if="item.fh")
                          div.text-center(:title="$t('ui.first_half')") {{ $t('ui.first_half') }}
                        th(v-if="item.sh")
                          div.text-center(:title="$t('ui.second_half')") {{ $t('ui.second_half') }}
                        th(v-if="item.tie")
                          div.text-center(:title="$t('ui.tie')") {{ $t('ui.tie') }}
                    tbody
                      tr
                        td(v-if="item.fh")
                          div.text-center(:class="{'up': item.fh_blink }") {{ item.fh }}
                        td(v-if="item.sh")
                          div.text-center(:class="{'up': item.sh_blink }") {{ item.sh }}
                        td(v-if="item.tie")
                          div.text-center(:class="{'up': item.tie_blink }") {{ item.tie }}
                div.mb-2(v-if="item.fodd || item.feven" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th
                          div {{ $t('ui.full_time_oe') }}
                    tbody
                      tr
                        td
                          div.text-center(:class="{'up': item.fodd_blink }") {{ item.fodd }}
                          div.text-center(:class="{'up': item.feven_blink }") {{ item.feven }}
                div.mb-2(v-if="item.hodd || item.heven" style="width: 33%;")
                  table.tablex#contentArea.clusterize-content
                    thead
                      tr
                        th
                          div {{ $t('ui.half_time_oe') }}
                    tbody
                      tr
                        td
                          div.text-center(:class="{'up': item.hodd_blink }") {{ item.hodd }}
                          div.text-center(:class="{'up': item.heven_blink }") {{ item.heven }}

</template>

<script>

export default {
  components: {
  },
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
// .fixed-header-table {
//   thead tr th {
//     background: darkgray !important;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(1) th{
//     position: sticky;
//     top: 0;
//     z-index: 10;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(2) th{
//     position: sticky;
//     top: 29px !important;
//     z-index: 10;
//   }
// }
</style>
